import { Dispatch, ExtraArgs, GetState } from '../../types'
import { fetchLoaderHelper } from '../redux/loader/thunksFor'
import fetchActionCreatorsFor from '../redux/fetch/actionCreatorsFor'
import { FetchAction } from '../redux/fetch/model'
import { FEATURES_COMPATIBILITY_PREFIX, FEATURES_COMPATIBILITY_RESOURCE_NAME, FeaturesCompatibility } from './model'

export type FeaturesCompatibilityAction =
  | FetchAction<FeaturesCompatibility>

// Basic Actions Creators

export const featuresCompatibilityActionCreators = (origin?: string) => {
  return {
    ...fetchActionCreatorsFor<FeaturesCompatibility>(FEATURES_COMPATIBILITY_RESOURCE_NAME, FEATURES_COMPATIBILITY_PREFIX, origin)
  }
}

// Thunks

export const fetchFeaturesCompatibility = (orgId: string, envId: string, resType: string, resId: string, origin?: string) =>
  (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
    return fetchLoaderHelper<FeaturesCompatibility>(dispatch, featuresCompatibilityActionCreators(origin), async () => {
      return api.ui(getState)
        .fetchCompatibility(orgId, envId, resType, resId)
        .then(response => {
          return response
        })
    })
  }
